import { render, staticRenderFns } from "./FeedSocialButtons.vue?vue&type=template&id=6287b58d&"
import script from "./FeedSocialButtons.vue?vue&type=script&lang=js&"
export * from "./FeedSocialButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports